import {UNLOCK_CHOICE_PRICE_NEGOTIATION_SHOWN_STORAGE_KEY} from "../constants/unlock_choice_price_negotiation";

export const wasUnlockChoicePriceNegotiationShownInSession = (): boolean => {
    try {
        return window.sessionStorage.getItem(UNLOCK_CHOICE_PRICE_NEGOTIATION_SHOWN_STORAGE_KEY) === "true";
    } catch {
        return false;
    }
};

export const markUnlockChoicePriceNegotiationShownInSession = (): boolean => {
    try {
        window.sessionStorage.setItem(UNLOCK_CHOICE_PRICE_NEGOTIATION_SHOWN_STORAGE_KEY, "true");

        return true;
    } catch {
        return false;
    }
};
import {UNLOCK_CHOICE_PRICE_NEGOTIATION_SHOWN_STORAGE_KEY} from "../constants/unlock_choice_price_negotiation";

export const wasUnlockChoicePriceNegotiationShownInSession = (): boolean => {
    try {
        return window.sessionStorage.getItem(UNLOCK_CHOICE_PRICE_NEGOTIATION_SHOWN_STORAGE_KEY) === "true";
    } catch {
        return false;
    }
};

export const markUnlockChoicePriceNegotiationShownInSession = (): boolean => {
    try {
        window.sessionStorage.setItem(UNLOCK_CHOICE_PRICE_NEGOTIATION_SHOWN_STORAGE_KEY, "true");

        return true;
    } catch {
        return false;
    }
};
